export default "__VITE_ASSET__DPT6R6YG__"